import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { ProjectPortfolio, projectPortfolio } from "@planzone/dto";
import { ActivityWatcher } from "@common/activityWatcher";
import { ColorPicker } from "@common/colorPicker";
import { Props } from "./types";
import styles from "./styles.scss";
import icon from "./icon.svg";

function Form(props: Props) {
  const { t } = useTranslation();
  const [portfolio, setPortfolio] =
    React.useState<ProjectPortfolio>(projectPortfolio);
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className={styles.form}>
      <div className={styles.iconBox}>
        {!!portfolio.color ? (
          <div
            className={styles.icon}
            style={{ backgroundColor: portfolio.color }}
            onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
          />
        ) : (
          <img
            className={styles.icon}
            src={icon}
            alt="icon"
            onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
          />
        )}
        {isOpen && (
          <div className={styles.colorPicker}>
            <ColorPicker
              color={portfolio.color}
              pick={(color) => setPortfolio({ ...portfolio, color })}
            />
          </div>
        )}
      </div>
      <div className={styles.group}>
        <input
          type="text"
          className={styles.input}
          placeholder={t("portfolioAssignation.name")}
          value={portfolio.name}
          onChange={({ target }) => {
            setPortfolio({ ...portfolio, name: target.value });
          }}
          onKeyUp={({ key }) => {
            if (key === "Enter" && !props.isRequestPending) {
              props.submit(portfolio);
              setPortfolio({ ...portfolio, name: "", color: "" });
            }
          }}
          autoFocus
        />
      </div>
    </div>
  );
}

export { Form };
